import { mediaCards } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Blurred%20backstage%20corridor%20with%20dramatic%20spotlight%20beam%20and%20tense%20atmosphere%2C%20behind%20the%20scenes%20entertainment%20drama%2C%20warm%20amber%20and%20deep%20shadow%20contrast%20lighting%2C%20paparazzi%20hidden%20camera%20aesthetic%2C%20cinematic%20thriller%20mood%2C%20celebrity%20scandal%20documentary%20style&width=500&height=300&seq=media-card-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=TV%20production%20studio%20set%20with%20dramatic%20red%20warning%20light%20glow%20and%20empty%20director%20chairs%2C%20broadcast%20conflict%20tension%20atmosphere%2C%20control%20room%20monitors%20in%20background%20shadows%2C%20cinematic%20documentary%20photography%2C%20dark%20moody%20behind%20the%20scenes%20aesthetic&width=500&height=300&seq=media-card-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Partial%20view%20of%20luxury%20modern%20mansion%20interior%20through%20dramatic%20curtains%20and%20warm%20shadow%20patterns%2C%20exclusive%20peek%20atmosphere%2C%20golden%20ambient%20lighting%20with%20rich%20textures%2C%20lifestyle%20investigative%20journalism%20aesthetic%2C%20mysterious%20wealthy%20lifestyle%20mood&width=500&height=300&seq=media-card-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dramatic%20compilation%20montage%20of%20entertainment%20headlines%20and%20paparazzi%20camera%20flashes%20in%20dark%20studio%20space%2C%20year%20in%20review%20documentary%20style%2C%20warm%20accent%20spots%20on%20black%20background%2C%20news%20media%20retrospective%20aesthetic%2C%20high%20energy%20tension%20collage%20mood&width=500&height=300&seq=media-card-4&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
            视频爆料
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            爆料视频
          </h2>
          <p className="text-sm text-foreground-500 mt-2">独家现场视频与深度深扒影像</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaCards.map((card, idx) => (
            <article
              key={card.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={mediaImages[idx]}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded-md">
                  {card.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
                  {card.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}